module.exports = __webpack_public_path__ + "order/img/XX.0942ed73.svg";